import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
const fadeInOverlay = keyframes `
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
export const AnimatedButton = styled.button `
  animation: ${fadeInOverlay} 0.2s ease-in-out forwards;

  .plus-icon {
    width: 1.2rem;
    height: 1.2rem;
  }

  .cart-icon {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
//# sourceMappingURL=AddToCartButton.styled.js.map